/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useEffect,
  useRef,
  useMemo,
  useLayoutEffect,
  useCallback,
  memo,
} from 'react';
import { css, jsx } from '@emotion/core';
import getTopics from 'services/apiHelpers/getTopics';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import { useSelector } from 'react-redux';
import onScrollEnds from 'services/onScrollEnds';
import pubSub from 'services/pubSub';

const HiddenBackButton = ({ id }) => {
  const [disabled, setDisabled] = useState(false);
  const currentTopic = useSelector(({ currentTopic }: any) => currentTopic);

  const isMounted = useRef(true);

  const getInteractions = () =>
    Array.from(document.querySelectorAll('[data-section]'));

  const getPrevSection = () => {
    const interactions = getInteractions();

    const currentSectionIndex = interactions.findIndex(
      (i: any) => i.id === `i${id}`
    );

    const prevSection = interactions[currentSectionIndex - 1];

    return prevSection;
  };

  const getPrevTopic = () => {
    const topics: any = getTopics();

    const prevTopic =
      topics[topics.findIndex((t: any) => t.id === currentTopic) - 1];

    return prevTopic;
  };

  const navToPrevTopic = () => {
    if (window.locationHistory) {
      window.location.hash = window.locationHistory;
      return (window.locationHistory = null);
    }

    const prevTopic = getPrevTopic();

    if (!prevTopic) return;

    setCurrentTopic(prevTopic.id);
    requestAnimationFrame(() => {
      const interactions = getInteractions();
      interactions[interactions.length - 1].scrollIntoView();
    });
  };

  const goBack = () => {
    const prevSection: any = getPrevSection();

    if (prevSection) {
      prevSection.scrollIntoView({
        behavior: 'smooth',
      });

      onScrollEnds(() => {
        prevSection.focus();
      });
    } else {
      navToPrevTopic();
    }
  };

  const isModulesFirstInteraction = () => {
    const isTopic0 =
      getTopics().findIndex((t: any) => t.id === currentTopic) === 0;
    const hasPrevSection = !!getPrevSection();

    if (isTopic0) {
      if (!hasPrevSection) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    if (isModulesFirstInteraction()) {
      setDisabled(true);
    }

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <button
      css={css`
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        border: 0;
        outline: 0;
        overflow: hidden;
      `}
      disabled={disabled}
      onClick={goBack}
      onFocus={() => {
        pubSub.publish('HILITE_CHAMELEON_BACK_BUTTON', { toggle: true });
      }}
      onBlur={() => {
        pubSub.publish('HILITE_CHAMELEON_BACK_BUTTON', { toggle: false });
      }}
      aria-label="Go back"
    >
      {/* {id} */}
      Go back
    </button>
  );
};

export default HiddenBackButton;
